import { provideRouter, Routes, withComponentInputBinding, withViewTransitions } from '@angular/router';

import { AuthGuard } from '@common/guards/auth.guard';
import { StripeComponent } from './pages/stripe/stripe.component';
import { WorkspaceGuard } from './pages/main/workspace.guard';
import { UserGuard } from './pages/main/user.guard';
import { guardsInOrder } from '@common/guards/ordered.guard';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/main' },
  {
    path: 'main',
    loadChildren: () => import('./pages/main/main.routes').then(m => m.MAIN_ROUTES),
    canActivate: [guardsInOrder(AuthGuard, [WorkspaceGuard, UserGuard])],
  },
  {
    path: 'signin',
    loadChildren: () => import('./pages/login/login.routes').then(m => m.AUTH_ROUTES),
    title: 'Sign In',
  },
  {
    path: 'signup',
    loadChildren: () => import('./pages/login/login.routes').then(m => m.AUTH_ROUTES),
    data: { isSignup: true },
    title: 'Sign Up',
  },
  {
    path: 'stripe',
    component: StripeComponent,
  },
  {
    path: 'order',
    loadChildren: () => import('./pages/order/order.routes').then(m => m.SUBSCRIPTION_ROUTES),
  },
  { path: '**', redirectTo: '/main' },
];

export const appRoutingProviders = [provideRouter(routes, withComponentInputBinding(), withViewTransitions({}))];
